import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MobileTimeIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.33329 14.6666C12.0152 14.6666 15 11.6819 15 7.99998C15 4.31808 12.0152 1.33331 8.33329 1.33331C4.65139 1.33331 1.66663 4.31808 1.66663 7.99998C1.66663 11.6819 4.65139 14.6666 8.33329 14.6666Z"
        stroke={fillColor || '#9D9DA6'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.33331 4V8H11.3333" stroke={fillColor || '#9D9DA6'} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export { MobileTimeIcon };
